//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 页面1
import outletGate from "./com/outletGate"; // 进口加药间

import jinkou from "./com/jinkou"; // 进口加药间

import threeSite from "./com/threeSite"; // 进出口闸门

import jinchu from "./com/jinchu";
export default {
  data: function data() {
    return {
      autoplaySpeed: 60000,
      number: 0
    };
  },
  mounted: function mounted() {
    console.log('我是父组件-----------------------------'); // this.goview(0)

    this.$refs.jinchu.clearTimer();
    this.$refs.jinchu.initData();
  },
  components: {
    jinchu: jinchu,
    outletGate: outletGate,
    jinkou: jinkou,
    threeSite: threeSite
  },
  methods: {
    onChange: function onChange(index) {
      this.number = index;
      console.log(index);

      switch (index) {
        case 0:
          this.$refs.jinchu.clearTimer();
          this.$refs.jinchu.initData();
          break;

        case 1:
          this.$refs.jinkou.clearTimer();
          this.$refs.jinkou.initData();
          break;

        case 2:
          this.$refs.chukou.clearTimer();
          this.$refs.chukou.initData();
          break;

        case 3:
          this.$refs.threeSite.clearTimer();
          this.$refs.threeSite.initData();
          break;
      }
    },
    goview: function goview() {
      if (this.number == 3) {
        this.$refs.viewBox.goTo(0);
      }

      if (this.number == 0) {
        this.$refs.viewBox.goTo(3);
      }
    }
  }
};